import { createContext } from "react";

const TickerContext = createContext({

});

export default TickerContext;